import { useAuth } from '@/hooks/auth/useAuth';
import { useAvailableSocieties } from '@/routes/outil-pro/hooks/societies/useAvailableSocieties';

/**
 * Société au nom de laquelle un EXTERNAL agit sur une stratégie garantie.
 *
 * Un user multi-société (ex. tête de groupe + agence décentralisée) consulte
 * les garanties de plusieurs stratégies : droits et configuration doivent alors
 * suivre la société concernée, pas sa société principale. La société candidate
 * n'est retenue que si elle représente une stratégie de l'utilisateur ; sinon
 * (garantie héritée d'un parent, société hors périmètre) → société principale.
 *
 * INTERNAL : la société candidate telle quelle.
 */
export const useWarrantyScopeSocietyId = (candidateSocietyId: string | undefined): string | undefined => {
  const { user } = useAuth();
  const { societies } = useAvailableSocieties('warrantyPolicy');

  if (user?.type !== 'EXTERNAL') return candidateSocietyId;
  return societies.some((s) => s.societyId === candidateSocietyId) ? candidateSocietyId : user.societyId;
};
